import { c as _c } from "react/compiler-runtime";
import { track } from "@opensea/analytics";
import { classNames, Media } from "@opensea/ui-kit";
import { Close, ProgressActivity } from "@opensea/ui-kit/icons";
import { useTranslations } from "next-intl";
import { useCallback, useEffect, useRef } from "react";
import { useShallow } from "zustand/react/shallow";
import { expandedSearchTransitionClassNames } from "./constants";
import { ExpandedSearchMenuPart } from "./ExpandedSearchMenuPart";
import { useExpandedSearchStore } from "./ExpandedSearchStore";
export function ExpandedSearchMenuInput(t0) {
  const $ = _c(39);
  const {
    query,
    setQuery,
    onKeyDown,
    selectedCategory
  } = t0;
  const t = useTranslations("ExpandedSearchMenuInput");
  const [open, setOpen, loading, setSearchQuery] = useExpandedSearchStore(useShallow(_temp));
  const inputRef = useRef(null);
  const hasTrackedSearchStarted = useRef(false);
  let t1;
  let t2;
  if ($[0] !== open || $[1] !== selectedCategory) {
    t1 = () => {
      if (open && selectedCategory !== "opensea-ai") {
        inputRef.current?.focus();
      } else {
        inputRef.current?.blur();
      }
    };
    t2 = [open, selectedCategory];
    $[0] = open;
    $[1] = selectedCategory;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[4] !== query) {
    t3 = () => {
      if (!inputRef.current) {
        return;
      }
      inputRef.current.value = query;
    };
    t4 = [query];
    $[4] = query;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  useEffect(t3, t4);
  let t5;
  if ($[7] !== selectedCategory) {
    t5 = () => {
      if (!hasTrackedSearchStarted.current) {
        track("Search Started", {
          category: selectedCategory
        });
        hasTrackedSearchStarted.current = true;
      }
    };
    $[7] = selectedCategory;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const handleFocus = t5;
  let t6;
  if ($[9] !== open || $[10] !== selectedCategory) {
    t6 = () => {
      if (open && selectedCategory !== "opensea-ai") {
        inputRef.current?.focus();
      }
    };
    $[9] = open;
    $[10] = selectedCategory;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== setQuery) {
    t7 = e => {
      setQuery(e.target.value.trim());
    };
    $[12] = setQuery;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t) {
    t8 = t("searchPlaceholder");
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== handleFocus || $[17] !== onKeyDown || $[18] !== t6 || $[19] !== t7 || $[20] !== t8) {
    t9 = <input autoComplete="off" className="w-full bg-transparent text-display-sm outline-hidden" data-testid="ExpandedSearchMenuInput" id="expanded-search-input" name="expanded-search-query" onBlur={t6} onChange={t7} onFocus={handleFocus} onKeyDown={onKeyDown} placeholder={t8} ref={inputRef} type="text" />;
    $[16] = handleFocus;
    $[17] = onKeyDown;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  const t10 = loading && "scale-100 opacity-100";
  let t11;
  if ($[22] !== t10) {
    t11 = classNames("scale-50 opacity-0", expandedSearchTransitionClassNames, t10);
    $[22] = t10;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <ProgressActivity fill="text-secondary" />;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t11) {
    t13 = <div className={t11}>{t12}</div>;
    $[25] = t11;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== query || $[28] !== selectedCategory || $[29] !== setOpen || $[30] !== setSearchQuery) {
    t14 = () => {
      track("Search Dismissed", {
        query,
        query_length: query.length,
        category: selectedCategory,
        has_query: query.length > 0,
        dismiss_source: "close_button"
      });
      setOpen(false);
      setSearchQuery("");
    };
    $[27] = query;
    $[28] = selectedCategory;
    $[29] = setOpen;
    $[30] = setSearchQuery;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <Close size={27.5} />;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t14) {
    t16 = <Media lessThan="lg"><button onClick={t14} type="button">{t15}</button></Media>;
    $[33] = t14;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== t13 || $[36] !== t16 || $[37] !== t9) {
    t17 = <ExpandedSearchMenuPart className="h-20 w-full items-center justify-center gap-3 border-border-1 border-b px-6">{t9}{t13}{t16}</ExpandedSearchMenuPart>;
    $[35] = t13;
    $[36] = t16;
    $[37] = t9;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  return t17;
}
function _temp(state) {
  return [state.open, state.setOpen, state.loading, state.setSearchQuery];
}